export default __webpack_public_path__ + "static/media/Gida of the Riftcaller.efded0ff.jpg";